import { render } from "./ScoreboardView.vue?vue&type=template&id=21023318&scoped=true"
import script from "./ScoreboardView.vue?vue&type=script&lang=js"
export * from "./ScoreboardView.vue?vue&type=script&lang=js"

import "./ScoreboardView.vue?vue&type=style&index=0&id=21023318&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21023318"]])

export default __exports__